import React from 'react';
import PropTypes from 'prop-types';
import Draggable from 'react-draggable';
import { Dialog } from '@glu/modal-react';
import { LinesNextIcon } from '@glu/icons-react';
import { withStyles } from '@glu/theming';
import styles from './DraggableModal.styles';


const DraggableModal = ({
  children, classes, closeModal, footer, isOpen, title
}) => (isOpen ? (
  <Draggable cancel={`.${classes.dialogBody},.${classes.footer}`}>
    <div className={classes.root}>
      <Dialog
        hideBackdrop
        suppressIcon
        show
        classes={{
          close: classes.close,
          header: classes.dialogHeader,
          modalBody: classes.dialogBody,
          modalFooter: classes.footer
        }}
        header={(
          <div className={classes.header}>
            <LinesNextIcon fill="#4c4c4c" height={16} width={16} />
            <h1>{title}</h1>
          </div>
          )}
        closeModal={closeModal}
        footer={footer}
        className={classes.dialogRoot}
      >
        {children}
      </Dialog>
    </div>
  </Draggable>
) : null);

DraggableModal.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  closeModal: PropTypes.func.isRequired,
  footer: PropTypes.node,
  // eslint-disable-next-line react/no-unused-prop-types
  initialPosition: PropTypes.shape({
    x: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    y: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  isOpen: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  maxWidth: PropTypes.number,
  // eslint-disable-next-line react/no-unused-prop-types
  minWidth: PropTypes.number,
  title: PropTypes.string.isRequired
};

DraggableModal.defaultProps = {
  children: null,
  footer: null,
  initialPosition: { x: 0, y: 0 },
  isOpen: false,
  maxWidth: 687,
  minWidth: 687
};

export default withStyles(styles)(DraggableModal);
